/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import { useTranslation } from "react-i18next";
import Row from "../../../common/core/Row";
import Col from "../../../common/core/Col";

const Home = () => {
  const { t } = useTranslation(["common"]);

  return (
    <Row>
      <Col xs="12">
        <Row>
          <Col xs="6" className="pr-0">
            <span className="text-center">
              {t("common:home")}
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Home;
